module.exports = __webpack_public_path__ + "img/content1.1c097e9e.png";